import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { useSEO } from "@/hooks/useSEO";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Counters } from "@/components/home/Counters";
import { WhyGpu } from "@/components/home/WhyGpu";
import { Principle } from "@/components/home/Principle";
import { Compare } from "@/components/home/Compare";
import { ProcessSteps } from "@/components/home/ProcessSteps";
import { Shield } from "@/components/home/Shield";
import { SafeTrade } from "@/components/home/SafeTrade";
import { AntiCounterfeit } from "@/components/home/AntiCounterfeit";
import { BenefitsSection } from "@/components/shared/BenefitGrid";
import { CommitteePreview } from "@/components/home/CommitteePreview";
import { UpdatesPreview } from "@/components/home/UpdatesPreview";
import { ResourcePreview } from "@/components/home/ResourcePreview";
import { VerifyCta, FinalCta } from "@/components/home/Cta";

export default function Home() {
  const { t } = useI18n();
  useSEO({
    title: "Gujarat Pharma Union — Pharmaceutical Trade Association Gujarat",
    description:
      "Gujarat Pharma Union unites licensed pharmaceutical traders, wholesalers, distributors and stockists in Gujarat around compliance, genuine medicines, verified vendors and structured member protection.",
    path: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Gujarat Pharma Union",
      alternateName: "GPU",
      description: t("footer.tagline"),
      areaServed: "Gujarat, India",
      slogan: "Unity • Compliance • Protection",
      url: typeof window !== "undefined" ? window.location.origin : undefined,
    },
  });

  return (
    <>
      <Hero />
      <Marquee />
      <Counters />
      <WhyGpu />
      <Principle />
      <Compare />
      <ProcessSteps />
      <Shield />
      <SafeTrade />
      <AntiCounterfeit />
      <BenefitsSection />
      <CommitteePreview />
      <UpdatesPreview />
      <ResourcePreview />
      <VerifyCta />
      <FinalCta />
    </>
  );
}
